import { Power0, Power3 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import { bindInViewTimelineStagger } from '../util/animations'

class GalleryItem {
  constructor ($el, masterTimeline) {
    this.$el = $el
    this.d = $el.width() / 1000
    if (typeof $el.data('animateIn') === 'undefined' || $el.data('animateIn') === true) {
      this.timelineIn = new TimelineMax({ paused: true, onComplete: () => { this.$el.data('animateInDone', true) } })
      this.buildTimelineIn()
      bindInViewTimelineStagger($el, this.timelineIn, masterTimeline)
    }
  }

  buildTimelineIn () {
    const $imgWrapper = this.$el.findElement('image')
    const $img = $imgWrapper.find('img')
    this.timelineIn
      .fromTo(
        $imgWrapper,
        this.d,
        { x: '-100%' },
        { x: '0%', ease: Power3.easeInOut },
        0
      )
      .fromTo(
        $img,
        this.d,
        { x: '100%' },
        { x: '0%', ease: Power3.easeInOut },
        0
      )
      .fromTo(
        $img,
        this.d / 2,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: Power0.easeNone },
        0
      )
  }
}

export default GalleryItem



// WEBPACK FOOTER //
// ./scripts/components/GalleryItem.js